import React, { Component } from "react";

import { Card } from "components/Card/Card.jsx";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Table,
    Modal
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import { connect } from "react-redux";
import { addNewDriver, removeDriver, selectDriver,updateDriver } from '../../redux/actions'
import { NotificationManager } from 'react-notifications';
import { PersianNumber } from '@thg303/react-persian'

const mapStateToProps = (state) => {
    return {
        drivers: state.drivers
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addNewDriver: (driver) => dispatch(addNewDriver(driver)),
        removeDriver: (driver) => dispatch(removeDriver(driver)),
        selectDriver: (driver) => dispatch(selectDriver(driver)),
        updateDriver: (driver, update) => dispatch(updateDriver(driver, update))
    }
}

class Services extends Component {
    constructor(props) {
        super(props);
        this.state = {
            driver: {
                id: -1,
                firstName: '',
                lastName: '',
                // plak: '',
                phone: '',
                car: ''
            },
            show: false
        }

        this.changeFirstName = this.changeFirstName.bind(this);
        this.changeLastName = this.changeLastName.bind(this);
        this.changePlak = this.changePlak.bind(this);
        this.changeCar = this.changeCar.bind(this);
        this.changePhone = this.changePhone.bind(this);


        this.addNewDriverBtn = this.addNewDriverBtn.bind(this);
        this.removeDriver = this.removeDriver.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.viewDriver = this.viewDriver.bind(this);
        this.validateDriverData = this.validateDriverData.bind(this);

        this.changeDriverStatus = this.changeDriverStatus.bind(this);
    }

    viewDriver(prop) {
        return this.props.selectDriver(prop)
    }



    handleHide() {
        this.setState({ show: false });
        this.setState({ driver: { firstName: '', lastName: '', plak: '', car: '', phone: '' } })
    }

    handleRemove() {
        this.props.removeDriver(this.state.driver);
        NotificationManager.success("راننده با موفقیت حذف شد", "انجام شد");
        this.handleHide();
    }

    removeDriver(prop) {
        this.setState({ driver: prop });
        this.setState({ show: true });
    }

    changeCar(e) {
        this.setState({ driver: { ...this.state.driver, car: e.target.value } });
    }

    changePhone(e) {
        this.setState({ driver: { ...this.state.driver, phone: e.target.value } });
    }

    changePlak(e) {
        this.setState({ driver: { ...this.state.driver, plak: e.target.value } });
    }


    changeFirstName(e) {
        this.setState({ driver: { ...this.state.driver, firstName: e.target.value } });
    }

    changeLastName(e) {
        this.setState({ driver: { ...this.state.driver, lastName: e.target.value } });
    }

    changeDriverStatus(driver) {
        let status = driver.isEnable ? true : false;
        let newDriver = { ...driver, isEnable: !status};
        this.props.updateDriver(driver, newDriver);
    }


    validateDriverData() {
        // 0917 219 5514
        const phoneRGX = /^[0][9][0-9]{9,9}$/;
        if (this.state.driver.firstName.length <= 0) {
            NotificationManager.error("نام را وارد کنید", "خطا");
            return false;
        }
        else if (this.state.driver.lastName.length <= 0) {
            NotificationManager.error("نام خانوادگی را وارد کنید", "خطا");
            return false;
        }
        else if (!phoneRGX.test(this.state.driver.phone)) {
            NotificationManager.error("شماره موبایل را صحیح وارد کنید", "خطا");
            return false;
        }
        return true;
    }


    addNewDriverBtn(e) {
        e.preventDefault();
        if (!this.validateDriverData())
            return;
        const newDriver = {
            id: this.props.drivers.length + 1,
            firstName: this.state.driver.firstName,
            lastName: this.state.driver.lastName,
            car: this.state.driver.car,
            isEnable: true,
            // plak: this.state.driver.plak,
            phone: this.state.driver.phone,
        };

        this.props.addNewDriver(newDriver);
        this.firstName.value = '';
        this.lastName.value = '';
        this.car.value = '';
        // this.plak.value = '';
        this.phone.value = 0;

        this.setState({
            driver: {
                id: -1,
                isEnable: true,
                firstName: '',
                lastName: '',
                car: '',
                // plak: '',
                phone: '',
            }
        });
        NotificationManager.success("راننده جدید افزوده شد", "انجام شد");

    }



    componentWillMount() {
        console.log("this is log component");
    }

    render() {
        return (
            <div className="content righter">
                <Grid fluid style={{ marginTop: '30px' }}>
                    <Row >
                        <Col xs={12}>
                            <Card
                                title="راننده‌ها"
                                content={
                                    <Grid fluid>

                                        <Row className="float-right">
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>نام خانوادگی</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        // value={this.state.customer.lastName}
                                                        bsClass="form-control"
                                                        placeholder="نام خانوادگی"
                                                        inputRef={(ref) => { this.lastName = ref }}
                                                        defaultValue={this.state.driver.lastName}
                                                        onChange={this.changeLastName}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>نام</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        // value={this.state.customer.lastName}
                                                        bsClass="form-control"
                                                        placeholder="نام"
                                                        inputRef={(ref) => { this.firstName = ref }}
                                                        defaultValue={this.state.driver.firstName}
                                                        onChange={this.changeFirstName}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>شماره تماس</ControlLabel>
                                                    <FormControl
                                                        type="number"
                                                        // value={this.state.customer.lastName}
                                                        bsClass="form-control"
                                                        placeholder="شماره تماس"
                                                        onFocus={() => this.phone.value = ""}
                                                        inputRef={(ref) => { this.phone = ref }}
                                                        defaultValue={this.state.driver.phone}
                                                        onChange={this.changePhone}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <ControlLabel>نوع خودرو</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        // value={this.state.customer.lastName}
                                                        bsClass="form-control"
                                                        placeholder="نوع خودرو"
                                                        inputRef={(ref) => { this.car = ref }}
                                                        defaultValue={this.state.driver.car}
                                                        onChange={this.changeCar}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Button bsStyle="info" onClick={this.addNewDriverBtn} pullRight fill type="submit">
                                            اضافه کردن
                                            </Button>
                                        <div className="clearfix" />
                                        <hr />
                                        <Row>
                                            <Table striped hover >
                                                <thead>
                                                    <tr>
                                                        <th className="text-right">
                                                            شماره
                                                </th>
                                                        <th className="text-right">
                                                            نام و نام خانوادگی
                                                </th>
                                                        <th className="text-right">
                                                            تماس
                                                </th>
                                                        <th className="text-right">
                                                            خودرو
                                                </th>
                                                        <th className="text-right">
                                                            وضعیت
                                                </th>
                                                        <th className="text-right">
                                                            حذف
                                                </th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.drivers.map((prop, key) => {
                                                        return (
                                                            <tr key={key} >
                                                                <td><PersianNumber>{key + 1}</PersianNumber></td>
                                                                <td>{prop.lastName} {prop.firstName}</td>
                                                                <td><PersianNumber>{prop.phone}</PersianNumber></td>
                                                                <td>{prop.car}</td>
                                                                <td style={{ minWidth: "130px", "cursor": "pointer" }} className="text-primary status" onClick={() => this.changeDriverStatus(prop)}>{prop.isEnable ? (<span className="enable"></span>) : (<span className="disable"></span>)}</td>
                                                                <td style={{ "cursor": "pointer" }} className="text-warning" onClick={() => this.removeDriver(prop)}>حذف </td>

                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </Grid>
                                }
                            />
                        </Col>

                        <Modal
                            show={this.state.show}
                            onHide={this.handleHide}
                            container={this}
                            aria-labelledby="contained-modal-title"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title">
                                    حذف راننده
                        </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                آیا میخواهید  راننده انتخابی را حذف کنید ؟
                    </Modal.Body>
                            <Modal.Footer>
                                <Button onClick={this.handleHide}>بستن</Button>
                                <Button bsStyle="danger" onClick={this.handleRemove}>حذف</Button>
                            </Modal.Footer>
                        </Modal>

                    </Row>
                </Grid>
            </div>
        );
    }
}

const ServicesConnect = connect(mapStateToProps, mapDispatchToProps)(Services);

export default ServicesConnect;